import { useEffect } from 'react';

export const PageTitle = (props) => {
  useEffect(() => {
    document.title = props.title || '';
  }, [props.title]);
  return props.children;
};
